module.exports = __webpack_public_path__ + "materialdesignicons-webfont.ttf?d15c1216957060fac577af6151fb8cfe";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.ttf?v=2.8.94
// module id = 1532
// module chunks = 0